import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TransferStoreWorkshopModel } from 'src/app/models/maintenance/transfer-store-workshop.model';
import { TransferStoreWorkshopPrintModel } from 'src/app/models/print/maintenance/transfer-store-workshop-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransferStoreWorkshopService {

  constructor(private _httpClient: HttpClient) { }

  annulAsync(transferStoreWorkshopId: number): Observable<TransferStoreWorkshopModel> {
    return this._httpClient.put<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.AnnulAsync}/${transferStoreWorkshopId}`,
      null);
  }

  blockAsync(transferStoreWorkshopId: number): Observable<TransferStoreWorkshopModel> {
    return this._httpClient.put<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.BlockAsync}/${transferStoreWorkshopId}`,
      null)
  }

  changeStateAsync(transferStoreWorkshopId: number): Observable<TransferStoreWorkshopModel> {
    return this._httpClient.put<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.ChangeStateAsync}/${transferStoreWorkshopId}`,
      null);
  }

  createAsync(TransferStoreWorkshopModel: TransferStoreWorkshopModel): Observable<TransferStoreWorkshopModel> {
    return this._httpClient.post<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.CreateAsync}`,
      TransferStoreWorkshopModel);
  }

  deleteAsync(transferStoreWorkshopId: number): Observable<TransferStoreWorkshopModel> {
    return this._httpClient.delete<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.DeleteAsync}/${transferStoreWorkshopId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllTransferStoreWorkshopsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetAllTransferStoreWorkshopsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getByIdAsync(transferStoreWorkshopId: number): Observable<TransferStoreWorkshopModel> {
    return this._httpClient.get<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetByIdAsync}/${transferStoreWorkshopId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstTransferStoreWorkshopByKeysAsync(branchId: number): Observable<TransferStoreWorkshopModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetFirstTransferStoreWorkshopByKeys}`,
      { params: params });
  }

  getEmptyTransferStoreWorkshopPrint(): Observable<TransferStoreWorkshopPrintModel> {
    return this._httpClient.get<TransferStoreWorkshopPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetEmptyTransferStoreWorkshopPrint}`);
  }

  getLastTransferStoreWorkshopByKeysAsync(branchId: number): Observable<TransferStoreWorkshopModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetLastTransferStoreWorkshopByKeys}`,
      { params: params });
  }

  getNextTransferStoreWorkshopByKeysAsync(branchId: number, consecutive: number): Observable<TransferStoreWorkshopModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetNextTransferStoreWorkshopByKeys}`,
      { params: params });
  }

  getPermissionPrintAsync(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetPermissionPrint}`);
  }

  getPreviusTransferStoreWorkshopByKeysAsync(branchId: number, consecutive: number): Observable<TransferStoreWorkshopModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetPreviusTransferStoreWorkshopByKeys}`,
      { params: params });
  }

  getTransferStoreWorkshopByKeysByPrint(branchId: number, consecutive: number, transferStoreWorkshopId: number): Observable<TransferStoreWorkshopPrintModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive).set('transferStoreWorkshopId', transferStoreWorkshopId);
    return this._httpClient.get<TransferStoreWorkshopPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetTransferStoreWorkshopByKeysByPrintAsync}`,
      { params }
    );
  }

  getTransferStoreWorkshopByKeysAsync(branchId: number, consecutive: number): Observable<TransferStoreWorkshopModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.GetTransferStoreWorkshopByKeys}`,
      { params: params });
  }

  hasExistingTransferStoreWorkshop(branchId: number): Observable<boolean> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.HasExistingTransferStoreWorkshopAsync}`,
      { params: params }
    );
  }

  updateAsync(transferStoreWorkshopContract: TransferStoreWorkshopModel): Observable<TransferStoreWorkshopModel> {
    return this._httpClient.put<TransferStoreWorkshopModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshop.UpdateAsync}`,
      transferStoreWorkshopContract);
  }
}
